import { type ReactNode } from 'react'

import { type RecType } from '@/defs/rec'
import { type StatType } from '@/defs/stat'

import { StatRecColorId } from './StatRecColorId/StatRecColorId'
import { StatRecDeckFraction } from './StatRecDeckFraction/StatRecDeckFraction'
import { StatRecDeckTotal } from './StatRecDeckTotal/StatRecDeckTotal'
import { StatRecDeckTotalFull } from './StatRecDeckTotalFull/StatRecDeckTotalFull'
import { StatRecInclusion } from './StatRecInclusion/StatRecInclusion'
import { StatRecInclusionAddedCut } from './StatRecInclusionAddedCut/StatRecInclusionAddedCut'
import { StatRecInclusionGraphic } from './StatRecInclusionGraphic/StatRecInclusionGraphic'
import { StatRecLift } from './StatRecLift/StatRecLift'
import { StatRecRank } from './StatRecRank/StatRecRank'
import { StatRecReleaseDate } from './StatRecReleaseDate/StatRecReleaseDate'
import { StatRecSalt } from './StatRecSalt/StatRecSalt'
import { StatRecSpoilDate } from './StatRecSpoilDate/StatRecSpoilDate'
import { StatRecSynergy } from './StatRecSynergy/StatRecSynergy'
import { StatRecZScore } from './StatRecZScore/StatRecZScore'

type Props = {
  rec: RecType
  stat: StatType
}

type ConfigType = Record<StatType, ({ rec }: { rec: RecType }) => ReactNode>

const CONFIG: ConfigType = {
  colorId: ({ rec }) => <StatRecColorId rec={rec} />,
  deckFraction: ({ rec }) => <StatRecDeckFraction rec={rec} />,
  deckTotal: ({ rec }) => <StatRecDeckTotal rec={rec} />,
  deckTotalCommander: ({ rec }) => <StatRecDeckTotal rec={rec} variant='commander' />,
  deckTotalFull: ({ rec }) => <StatRecDeckTotalFull rec={rec} />,
  inclusion: ({ rec }) => <StatRecInclusion rec={rec} />,
  inclusionAdded: ({ rec }) => <StatRecInclusionAddedCut rec={rec} variant='added' />,
  inclusionCut: ({ rec }) => <StatRecInclusionAddedCut rec={rec} variant='cut' />,
  inclusionGraphic: ({ rec }) => <StatRecInclusionGraphic rec={rec} />,
  lift: ({ rec }) => <StatRecLift rec={rec} />,
  rank: ({ rec }) => <StatRecRank rec={rec} />,
  released: ({ rec }) => <StatRecReleaseDate rec={rec} />,
  salt: ({ rec }) => <StatRecSalt rec={rec} />,
  spoiled: ({ rec }) => <StatRecSpoilDate rec={rec} />,
  synergy: ({ rec }) => <StatRecSynergy rec={rec} />,
  zScore: ({ rec }) => <StatRecZScore rec={rec} />,
}

export const StatRec = ({ rec, stat }: Props) => CONFIG[stat]({ rec })
